<template>
   <v-content>
       <v-container>
          <v-card>
              <v-card-title><v-icon>supervised_user_circle</v-icon> Usuarios:
                  <v-spacer/>
                  <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                  />
                  <v-btn @click="openModal()" class="mx-2 py-0" color="primary"><v-icon>add_circle</v-icon></v-btn>
              </v-card-title>
              <v-data-table
                      :headers="headers"
                      :items="users"
                      :items-per-page="5"
                      :search="search"
                      class="elevation-1"
              >
                    <template v-slot:item.perfilId="{ item }">
                        <v-chip v-if="nombrePerfil(item.perfilId)" x-small color="primary" dark>
                            {{ nombrePerfil(item.perfilId) }}
                        </v-chip>
                        <span v-else class="grey--text text--lighten-1 caption">Sin acceso</span>
                    </template>
                  <template v-slot:item.actions="{ item }">
                      <v-icon
                              small
                              class="mr-2"
                              @click="editItem(item)"
                      >
                          edit
                      </v-icon>
                      <v-icon
                              small
                              @click="deleteItem(item)"
                      >
                          delete
                      </v-icon>
                  </template>
              </v-data-table>
          </v-card>
           <v-dialog
                   @click:outside="cerrarDialogo"
                   v-model="dialog"
                   width="600"

           >
               <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
                  <v-card>
                      <v-card-title class="headline text-center">{{edit ? 'Editar': 'Crear'}} usuario</v-card-title>
                      <v-form
                              @submit.prevent="handleSubmit(formSubmit)"
                              ref="form"
                              lazy-validation
                              class="container"
                      >
                          <v-row no-gutters>
                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required" name="first_name" v-slot="{ errors, valid }">
                                      <v-text-field
                                              :error-messages="errors"
                                              :success="valid"
                                              name="first_name"
                                              v-model="user.first_name"
                                              label="Nombre(s):"
                                              placeholder="Ingresa los nombres"
                                      />
                                  </ValidationProvider>

                              </v-col>
                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required" name="last_name" v-slot="{ errors, valid }">
                                      <v-text-field
                                              :error-messages="errors"
                                              :success="valid"
                                              name="last_name"
                                              v-model="user.last_name"
                                              label="Apellido(s):"
                                              placeholder="Ingresa los apellidos"
                                      />
                                  </ValidationProvider>

                              </v-col>
                          </v-row>
                          <v-row no-gutters>
                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required|email" name="email" v-slot="{ errors, valid }">
                                      <v-text-field
                                               v-if="edit"
                                               disabled
                                              :error-messages="errors"
                                              :success="valid"
                                              name="email"
                                              v-model="user.email"
                                              label="Email:"
                                              placeholder="Ingresa el correo electrónico"
                                      />
                                      <v-text-field
                                              v-else
                                              :error-messages="errors"
                                              :success="valid"
                                              name="email"
                                              v-model="user.email"
                                              label="Email:"
                                              placeholder="Ingresa el correo electrónico"
                                      />
                                  </ValidationProvider>

                              </v-col>
                              <v-col cols="12" md="6">
                                  <ValidationProvider v-if="edit === false" rules="required|min:8"  name="password" v-slot="{ errors, valid }">
                                      <v-text-field
                                              counter="8"
                                              :error-messages="errors"
                                              :success="valid"
                                              v-model="user.password"
                                              name="password"
                                              label="Contraseña:"
                                              placeholder="Ingresa tu contraseña"
                                      />

                                  </ValidationProvider>

                              </v-col>
                          </v-row>

                          <v-row no-gutters>
                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required" name="role" v-slot="{ errors, valid }">
                                      <v-select
                                              @change="changeRol()"
                                              :error-messages="errors"
                                              :success="valid"
                                              label="Rol"
                                              placeholder="Seleccione un rol"
                                              name="role"
                                              v-model="user.role"
                                              :items="roles"
                                      />
                                  </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6">
                                  <v-select
                                          v-model="user.perfilId"
                                          :items="opcionesPerfil"
                                          item-text="nombre"
                                          item-value="id"
                                          label="Acceso al panel"
                                          placeholder="Sin acceso al panel"
                                          prepend-icon="admin_panel_settings"
                                          hint="Define a que pantallas entra y que puede hacer en el panel web"
                                          persistent-hint
                                          clearable
                                  />
                              </v-col>
                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required" name="type" v-slot="{ errors, valid }">
                                      <v-select
                                              :error-messages="errors"
                                              :success="valid"
                                              label="Tipo"
                                              placeholder="Seleccione un tipo"
                                              name="type"
                                              v-model="user.type"
                                              :items="types"
                                      />
                                  </ValidationProvider>

                              </v-col>
                          </v-row>
                          <v-row no-gutters>
                              <v-col cols="12" md="6">
                                  <ValidationProvider :rules="rulesCargo" name="position" v-slot="{ errors, valid }">
                                      <v-select
                                              v-if="rulesCargo.length > 0"
                                              :error-messages="errors"
                                              :success="valid"
                                              label="Cargo"
                                              placeholder="Seleccione un cargo"
                                              name="position"
                                              v-model="user.position"
                                              :items="cargos"
                                      />

                                      <v-select
                                              v-else
                                              disabled
                                              :error-messages="errors"
                                              :success="valid"
                                              label="Cargo"
                                              placeholder="Seleccione un cargo"
                                              name="position"
                                              v-model="user.position"
                                              :items="cargos"
                                      />
                                  </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required" name="assignment" v-slot="{ errors, valid }">
                                      <v-select
                                              :error-messages="errors"
                                              :success="valid"
                                              label="Turno"
                                              placeholder="Seleccione un turno"
                                              name="assignment"
                                              v-model="user.assignment"
                                              :items="turnos"
                                      />
                                  </ValidationProvider>
                              </v-col>
                          </v-row>
                          <v-row no-gutters>
                              <v-col cols="12" md="6">
                                  <ValidationProvider rules="required" name="area" v-slot="{ errors, valid }">
                                      <v-select
                                              :error-messages="errors"
                                              :success="valid"
                                              label="Areas"
                                              placeholder="Seleccione un un area"
                                              name="area"
                                              v-model="user.area"
                                              :items="areas"
                                              item-text="name"
                                              item-value="name"
                                      />
                                  </ValidationProvider>
                              </v-col>
                              <v-col>
                                  <ValidationProvider rules="required" name="phone" v-slot="{ errors, valid }">
                                      <v-text-field
                                              label="Telefono"
                                              placeholder="Ingrese el numero de telefono"
                                              :error-messages="errors"
                                              :success="valid"
                                              name="phone"
                                              v-model="user.phone"
                                              type="number"
                                      />
                                  </ValidationProvider>
                              </v-col>
                          </v-row>
                          <v-card-actions>
                              <v-spacer/>
                              <v-btn text @click="cerrarDialogo">Cancelar</v-btn>
                              <v-btn type="submit" color="primary" :loading="guardando">{{edit ? 'Editar' : 'Guardar'}}</v-btn>
                          </v-card-actions>
                      </v-form>
                  </v-card>
               </ValidationObserver>
           </v-dialog>
           <v-snackbar
                   :color="snackColor"
                   :timeout="snackColor === 'error' ? 8000 : 5000"
                   v-model="snackbar"
           >
               {{ text }}
               <template v-slot:action="{ attrs }">
                   <v-btn
                           v-bind="attrs"
                           color="white"
                           text
                           @click="snackbar = false"
                   >
                       Cerrar
                   </v-btn>
               </template>
           </v-snackbar>
       </v-container>
   </v-content>
</template>

<script>

    import {ROLE, CARGO_VIGILANTE,TURNO, TYPE_VIGILANTE} from "../plugins/config"
    import { mapState, mapActions} from 'vuex'

    import {
        ValidationObserver,
    } from "vee-validate";

    export default {
        name: "Users",
        components:{
            ValidationObserver
        },
        data(){
            return{
                idUser:null,
                search:'',
                dialog:false,
                edit:false,
                guardando:false,
                snackbar:false,
                snackColor:'success',
                text:'',
                rulesCargo:'',
                roles: ROLE,
                types:TYPE_VIGILANTE,
                cargos:CARGO_VIGILANTE,
                turnos:TURNO,
                user:{
                    first_name:'',
                    last_name:'',
                    email:'',
                    password:'',
                    role:'',
                    type:'',
                    position:'',
                    assignment:'',
                    phone:'',
                    area:null,
                    perfilId:null,
                },
                userValid:true,
                headers: [
                    {
                        text: 'Nombre(s)',
                        align: 'left',
                        sortable: true,
                        value: 'first_name',
                    },
                    {
                        text: 'Apellido(s)',
                        align: 'left',
                        sortable: true,
                        value: 'last_name',
                    },
                    { text: 'E-mail', value: 'email' },
                    { text: 'Telefono', value: 'phone' },
                    { text: 'Rol', value: 'role' },
                    { text: 'Cargo', value: 'position' },
                    { text: 'Turno', value: 'assignment' },
                    { text: 'Tipo', value: 'type' },
                    { text: 'Area', value: 'area' },
                    { text: 'Panel', value: 'perfilId' },
                    { text: 'Opciones', value: 'actions' },
                ],

            }
        },
        mounted(){
            this.$store.dispatch('perfil/bindPerfiles')
        },
        watch:{
            // Se limpia el formulario tambien cuando el dialogo se cierra con Escape
            // o haciendo click afuera: si no, el alta siguiente arranca con los datos
            // del usuario que se habia abierto antes.
            dialog(abierto){
                if (!abierto) this.resetForm()
            }
        },
        methods:{
            ...mapActions([
                "createUser", "updateUser", 'deleteCollect'
            ]),

            nombrePerfil(perfilId){
                if (!perfilId) return null
                const perfil = (this.perfiles || []).find(p => p.id === perfilId)
                return perfil ? perfil.nombre : null
            },
            notify(mensaje, color){
                this.text = mensaje
                this.snackColor = color || 'success'
                this.snackbar = true
            },
            resetForm(){
                this.user = {
                    first_name:'',
                    last_name:'',
                    email:'',
                    password:'',
                    role:'',
                    type:'',
                    position:'',
                    assignment:'',
                    phone:'',
                    area:null,
                    perfilId:null,
                };
                this.idUser = null
                this.edit = false
                this.rulesCargo = ''
            },
            resetValidation(){
                this.$nextTick(() => {
                    if (this.$refs.obs) this.$refs.obs.reset()
                })
            },
            openModal(){
                this.resetForm();
                this.dialog = true;
                this.resetValidation();
            },
            changeRol(){
                if (this.user.role !== 'VIGILANTE'){
                    this.rulesCargo = '';
                    this.user.position = '';

                }else {
                    this.rulesCargo = "required";
                }
            },

            formSubmit(){
                if (this.edit){
                    this.editUser()
                } else {
                    this.saveUser()
                }
            },
            cerrarDialogo(){
                this.dialog = false
            },
            closeModal(text){
                this.dialog = false;
                this.notify(text, 'success');
            },
            deleteItem(item){
                const yo = this.$store.getters.user
                if (yo && item.id === yo.id) {
                    this.notify('No podes eliminar tu propio usuario.', 'error')
                    return
                }

                const nombre = [item.first_name, item.last_name].filter(Boolean).join(' ') || item.email
                if (!confirm('Vas a eliminar a ' + nombre + '. Esta accion no se puede deshacer.')) return

                this.deleteCollect({id:item.id, collection:'users'})
            },
            editItem(item){
                this.user ={
                    first_name:item.first_name,
                    last_name:item.last_name,
                    email:item.email,
                    role:item.role,
                    type:item.type,
                    position:item.position,
                    assignment:item.assignment,
                    phone:item.phone,
                    area:item.area,
                    perfilId:item.perfilId || null,
                };
                this.idUser = item.id
                // Sin esto el select de Cargo aparece deshabilitado al editar a un
                // VIGILANTE, porque rulesCargo solo se calculaba al cambiar el rol.
                this.rulesCargo = item.role === 'VIGILANTE' ? 'required' : ''
                this.edit = true
                this.dialog = true
                this.resetValidation()
            },
            // Quitarse a uno mismo el acceso deja al usuario afuera del panel y no
            // hay forma de recuperarse desde la interfaz: solo tocando Firestore a
            // mano. Por eso se bloquea.
            seQuitaElAcceso(){
                const yo = this.$store.getters.user
                if (!yo || this.idUser !== yo.id) return false

                // Misma precedencia que resolverSesion: manda el perfil asignado
                // siempre que exista y este activo; el rol ADMIN solo se usa como
                // retrocompatibilidad cuando no hay un perfil valido.
                const perfilNuevo = (this.perfiles || []).find(
                    p => p.id === this.user.perfilId && p.activo !== false
                )

                if (!perfilNuevo) return this.user.role !== 'ADMIN'
                if (perfilNuevo.sistema === true) return false

                // Con un perfil comun hay que conservar la pantalla de Usuarios:
                // es la unica desde donde se puede volver a asignar el acceso.
                return !(perfilNuevo.pantallas || []).includes('usuarios')
            },

            async editUser(){
                if (this.seQuitaElAcceso()) {
                    this.notify('No podes quitarte a vos mismo el acceso al panel. Pedile a otro administrador que lo haga.', 'error')
                    return
                }
                // Firestore rechaza los campos undefined (por ejemplo el cargo de un
                // usuario viejo que nunca lo tuvo): se guardan como null.
                const data = {}
                Object.keys(this.user).forEach(clave => {
                    data[clave] = this.user[clave] === undefined ? null : this.user[clave]
                })

                this.guardando = true
                try {
                    await this.updateUser({id:this.idUser, data});
                    this.closeModal('Se ha actualizado satisfactoriamente')
                } catch (e) {
                    this.notify(this.mensajeError(e, 'No se pudo actualizar el usuario'), 'error')
                } finally {
                    this.guardando = false
                }
            },
            async saveUser(){
                this.guardando = true
                try {
                    await this.createUser(this.user);
                    this.closeModal('Se ha creado satisfactoriamente')
                } catch (e) {
                    this.notify(this.mensajeError(e, 'No se pudo crear el usuario'), 'error')
                } finally {
                    this.guardando = false
                }
            },
            // Los mensajes de Firebase vienen en ingles y no dicen nada al operador.
            mensajeError(e, porDefecto){
                const codigos = {
                    'auth/email-already-in-use': 'Ya existe una cuenta con ese correo.',
                    'auth/invalid-email': 'El correo no tiene un formato valido.',
                    'auth/weak-password': 'La contrasenia es demasiado debil: usa al menos 8 caracteres.',
                    'auth/network-request-failed': 'No hay conexion con el servidor. Reintenta en un momento.',
                    'permission-denied': 'No tenes permisos para hacer este cambio.'
                }
                if (!e) return porDefecto
                // La cuenta de Auth se creo pero no se pudo borrar tras fallar el
                // documento: hay que limpiarla a mano antes de reintentar el alta.
                if (e.cuentaHuerfana) {
                    return 'No se pudo guardar el usuario y quedo una cuenta pendiente de limpieza (' + e.cuentaHuerfana + '). Avisale al area tecnica.'
                }
                return codigos[e.code] || e.message || porDefecto
            }
        },
        computed:{
            // Solo los perfiles activos se pueden asignar.
            opcionesPerfil(){
                return (this.perfiles || []).filter(p => p.activo !== false)
            },
            ...mapState({
                areas:state => state.area.areas,
                perfiles:state => state.perfil.perfiles,
                users:state =>state.user.users

            })
        }
    }
</script>

<style scoped>

</style>